export default __webpack_public_path__ + "static/media/icon-ic-chevron-left-gradient.1a59740f.svg";